import { render, staticRenderFns } from "./ConfigureStoredBrandQueryPopup.vue?vue&type=template&id=01cc0c6a&scoped=true&"
import script from "./ConfigureStoredBrandQueryPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfigureStoredBrandQueryPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigureStoredBrandQueryPopup.vue?vue&type=style&index=0&id=01cc0c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc0c6a",
  null
  
)

export default component.exports